"use client";

import React from "react";
import { useUserPlan } from "@/lib/hook/use-user-plan";
import ProPlansView from "./ProPlansView";

const ProPlansClient: React.FC = () => {
  const { data, isLoggedIn } = useUserPlan();

  return (
    <ProPlansView
      currentPlan={data?.plan || null}
      currentVariant={data?.variant || null}
      isLoggedIn={isLoggedIn}
      cancelAtPeriodEnd={data?.cancelAtPeriodEnd || false}
      currentPeriodEnd={data?.currentPeriodEnd || null}
      subscriptionStatus={data?.subscriptionStatus || "NONE"}
    />
  );
};

export default ProPlansClient;
